import React, { Component } from 'react';

import ReactDOM from 'react-dom';

class EditSpeakTextwithTextfield extends Component {
  constructor(props) {
    super(props);
    this.state = {
      question: this.props.question,
      correctanswer: this.props.correctanswer,
      subcategory: this.props.subcategory,
    };
  }

  handleQuestionChange(event) {
    this.setState({ question: event.target.value });
    this.props.selectedanswer(
      this.state.subcategory,
      event.target.value,
      event.target.value,
      ['1', '2', '3', '4']
    );
  }

  deletequestion() {
    ////console.log("Let me delete the question")
  }

  render() {
    return (
      <div className="questionBox">
        {/* <img className="photo" src = {this.state.question} /> */}
        <div className="centeranswer">
          <div> ID: {this.props.id} </div>

          <div>
            Words
            <input
              type="text"
              spellCheck="false"
              autoComplete="off"
              id="asa"
              value={this.state.question}
              onChange={(e) => {
                this.handleQuestionChange(e);
              }}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default EditSpeakTextwithTextfield;
